module.exports = __webpack_public_path__ + "img/pdf.af3c18c1.png";